module.exports = __webpack_public_path__ + "ea594a1f/img/layout-3.06b3c203.jpg";